/**
 * preorder-cart.js
 * ------------------------------------------------------------------
 * 予約商品と通常商品の「同梱制御」（フロント制御）。
 *  - 予約商品と通常在庫商品を同一カートに入れさせない
 *  - 廃版商品はカート追加を無効化（サーバ側でも disabled）
 *  - カート内に予約×通常が混在した場合はチェックアウトを抑止
 *
 * 判定は line item property `_preorder` を用いる。
 * ※JavaScript無効環境・カートURL直接操作では完全な防止は保証しない（仕様）。
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  var lang = (window.languages || {});
  var routes = (window.routes || {});
  var cartUrl = routes.cartUrl || '/cart';

  var MSG_ADD_PREORDER = lang.preorderMixAddPreorder || '予約商品は通常商品と同時にご購入いただけません。カート内の通常商品を削除してから予約商品を追加してください。';
  var MSG_ADD_NORMAL = lang.preorderMixAddNormal || '通常商品は予約商品と同時にご購入いただけません。カート内の予約商品を削除してから通常商品を追加してください。';
  var MSG_CHECKOUT = lang.preorderMixCheckout || '予約商品と通常商品が混在しているため購入手続きに進めません。どちらか一方のみでご購入ください。';
  var MSG_DISCONTINUED = lang.discontinuedNotice || 'この商品は販売を終了しました。';

  var state = { hasPreorder: false, hasNormal: false };

  // 予約商品がカートにある間、「お届け希望日時」(配送日時アプリ)を非表示にする。
  // 対象要素: #cart-delivery-datetime_section_os2
  // CSS(display:none)で制御するため、アプリが後から要素を描画しても確実に隠れ、
  // 予約商品をカートから外すと再表示される。
  function toggleDeliverySection(hide) {
    var STYLE_ID = 'preorder-hide-delivery-style';
    var style = document.getElementById(STYLE_ID);
    if (hide) {
      if (!style) {
        style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = '#cart-delivery-datetime_section_os2{display:none !important;}';
        document.head.appendChild(style);
      }
    } else if (style && style.parentNode) {
      style.parentNode.removeChild(style);
    }
  }

  function refresh() {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.hasPreorder = false;
        state.hasNormal = false;
        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          if (props._preorder) {
            state.hasPreorder = true;
          } else {
            state.hasNormal = true;
          }
        });
        guardCheckout();
        toggleDeliverySection(state.hasPreorder);
      })
      .catch(function () { /* 取得失敗時は制御しない */ });
  }

  // 追加しようとしている商品が予約商品かどうか
  function isAddingPreorder(btn) {
    if (!btn) return false;
    if (btn.getAttribute('data-preorder') === 'true') return true;
    var form = btn.closest('form');
    if (form && form.querySelector('input[name="properties[_preorder]"]')) return true;
    return false;
  }

  function isDiscontinued(btn) {
    return !!(btn && btn.getAttribute('data-discontinued') === 'true');
  }

  // 混在時：チェックアウトボタンを抑止
  function guardCheckout() {
    var mixed = state.hasPreorder && state.hasNormal;
    var buttons = document.querySelectorAll('button[name="checkout"], .Cart__Checkout');
    buttons.forEach(function (btn) {
      if (mixed) {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('is-disabled');
        if (!btn.parentNode.querySelector('.Cart__PreorderMixNotice')) {
          var note = document.createElement('p');
          note.className = 'Cart__PreorderMixNotice Alert Alert--error';
          note.textContent = MSG_CHECKOUT;
          btn.parentNode.insertBefore(note, btn);
        }
      } else {
        btn.removeAttribute('disabled');
        btn.classList.remove('is-disabled');
        var existing = btn.parentNode.querySelector('.Cart__PreorderMixNotice');
        if (existing) existing.parentNode.removeChild(existing);
      }
    });
  }

  // 追加クリックを capture フェーズで捕捉し、混在なら theme.js のハンドラより先に止める
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-action="add-to-cart"]') : null;
    if (!btn) return;

    if (isDiscontinued(btn)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.alert(MSG_DISCONTINUED);
      return;
    }

    var addingPreorder = isAddingPreorder(btn);

    if (addingPreorder && state.hasNormal) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.alert(MSG_ADD_PREORDER);
      return;
    }

    if (!addingPreorder && state.hasPreorder) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.alert(MSG_ADD_NORMAL);
      return;
    }

    // 追加が通った場合はカート状態を更新
    setTimeout(refresh, 900);
  }, true);

  // 初期化・カート更新イベントで状態を再取得
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  document.documentElement.addEventListener('cart:refresh', function () { setTimeout(refresh, 300); });
  document.documentElement.addEventListener('cart:updated', function () { setTimeout(refresh, 300); });
})();
